import React from 'react'

const ImageWidget = (props) => {

  return (
    <div className="mt-2">
      {props.formType == "edit" && <h5>Files uploaded</h5>}
      {props.files && props.files.map((file, index) => {
        console.log(file);
        if(file.uploaded == true) 
          return (
            <div className="">
              <h6 className="d-inline mr-2">{file.filename}</h6>
              <i className="fa fa-times" 
                onClick={() => props.deleteImage(file.fileId)}
              />
            </div>
          )
        }
      )}
      <hr />
      <h5>Files to be uploaded</h5>
      {props.files && props.files.map((file, index) => {
        if(file.uploaded == false) 
          return (
            <div className="">
              <h6 className="d-inline ">{file.filename}</h6>
            {/* <span className="fa fa-times"></span> */}
            </div>
          )
        }
      )}
    </div>
  )
}

export default ImageWidget;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ImageWidget.js